import React from "react";
import styled from "styled-components";
import { CompanyNewsItem } from "../../../models/newsModels";
import { EngagementTheme } from "../../../enums/EngagementTheme";
import { IconStack, IconStackItem } from "../../visuals/IconStack";
import {
  compassLightGreyBackground,
  greyText,
  lightGreyOutline,
} from "../../../styles";
import { THEME_TO_META_THEME } from "../../../utils/engagementThemeUtils";
import { ENGAGEMENT_META_THEME_IMAGES } from "../../../pages/CompanyEngagements/constants";
import {
  DEVELOPMENT_TYPE_LABELS,
  DIRECTION_COLORS,
  EVIDENCE_ROLE_LABELS,
  THEME_LABELS,
} from "./constants";
import { strongestRole } from "./utils";

type NewsTagsProps = {
  item: CompanyNewsItem;
};

const TagRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 0 7px;
  border: 1px solid ${lightGreyOutline};
  border-radius: 999px;
  font-family: "Apercu";
  font-size: 10.5px;
  color: ${greyText};
  white-space: nowrap;
`;

const ChipDot = styled.span<{ $color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $color }): string => $color};
`;

const toThemeStackItem = (theme: EngagementTheme): IconStackItem => ({
  key: theme,
  label: THEME_LABELS[theme],
  image: ENGAGEMENT_META_THEME_IMAGES[THEME_TO_META_THEME[theme]].logo,
});

const RoleChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  border-radius: 5px;
  background-color: ${compassLightGreyBackground};
  font-family: "ApercuMono", "Apercu", monospace;
  font-size: 10px;
  color: ${greyText};
  white-space: nowrap;
`;

export const NewsTags = ({ item }: NewsTagsProps): JSX.Element => {
  const [firstTheme, ...otherThemes] = item.themes;
  const role = strongestRole(item.evidence_roles);
  return (
    <TagRow>
      <Chip>
        <ChipDot $color={DIRECTION_COLORS[item.evidence_direction]} />
        {DEVELOPMENT_TYPE_LABELS[item.development_type]}
      </Chip>
      {firstTheme && (
        <Chip>
          <IconStack items={item.themes.map(toThemeStackItem)} size={12}>
            {THEME_LABELS[firstTheme]}
            {otherThemes.length > 0 && ` +${otherThemes.length}`}
          </IconStack>
        </Chip>
      )}
      {role && <RoleChip>{EVIDENCE_ROLE_LABELS[role]}</RoleChip>}
    </TagRow>
  );
};
